<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>
<script>
import { apiNoticeOK, repeatLogin } from '@/request/api';
import store from './store';
export default {
    name: 'App',
    data() {
        return {
            type: ''
        };
    },
    mounted() {
        window.addEventListener('keydown', (e) => {
            if (e.code == 'Enter') {
                e.preventDefault();
            }
        });

        // if (localStorage.getItem('local_token')) {
        //     let that = this;
        //     let timeID = setInterval(() => {
        //         repeatLogin({
        //             local_token: localStorage.getItem('local_token')
        //         }).then(res => {
        //             if (res.code !== 2000) {
        //                 clearInterval(timeID);
        //                 sessionStorage.removeItem('userToken');
        //                 localStorage.removeItem('local_token');
        //                 this.$alert('账号已在其他地方登录', '提示', {
        //                     confirmButtonText: '确定',
        //                     callback: action => {
        //                         that.$router.push('/login');
        //                     }
        //                 });
        //             }
        //         });
        //     }, 10000);
        //     this.$bus.data.SSO_timeID = timeID;
        // }
    },
    methods: {
        openPop() {
            let obj = {};
            let position = 'bottom-right';
            this.type = 'notice';
            if (this.system_notice.id) {
                obj = this.system_notice;
                this.type = 'system_notice';
                position = '';
            } else obj = this.notice;
            this.$notify({
                title: obj.title,
                dangerouslyUseHTMLString: true,
                message: obj.content,
                position: position,
                duration: 0,
                showClose: true,
                onClose: this.onClose,
                onClick: this.onClick
            });
        },
        onClose(e) {
            apiNoticeOK({
                send_type: this.$bus.data.type,
                id: this[this.type].id
            });
        },
        onClick() {
            this.$router.push({
                name: 'NoticeList',
                params: {
                    id: this[this.type].id
                }
            });
        }
    },
    computed: {
        informPop() {
            return store.state.informPop;
        },
        notice() {
            return store.state.notice;
        },
        system_notice() {
            return store.state.system_notice;
        }
    },
    watch: {
        notice: {
            handler(n) {
                // if (n.id) this.openPop();
            },
            deep: true,
            immediate: true
        },
        system_notice: {
            handler(n) {
                // if (n.id) this.openPop();
            },
            deep: true,
            immediate: true
        }
    }
};
</script>
<style>
@import './assets/css/main.css';
/* @import './assets/css/color-dark.css'; */
@import './assets/css/color-bule.scss';

/*深色主题*/
/* @import './assets/css/theme-green/color-green.css'; */
/* 浅绿色主题 */
.vxe-footer--row {
    font-weight: 600;
    color: red;
}
</style>
<style lang="scss">
// 打印样式
.printBox table {
    width: 100%;
    border-collapse: collapse;
    border: none;
}

.printBox table td,
.printBox table th {
    border: 1px solid #000;
    font-size: 12px;
}

.printBox table th {
    font-weight: bold;
    color: #000;
}

.company {
    font-size: 13px;
    color: rgb(7, 16, 114);
    font-weight: bold;
}

.printTitle {
    text-align: center;
    font-size: 20px;
    color: #000;
    font-weight: bold;
    letter-spacing: 5px;
}

.printTop {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    font-size: 16px;
    color: #000;
    border-bottom: 1px solid rgb(7, 16, 114);
}

.printTop div label {
    color: rgb(7, 16, 114);
    font-weight: bold;
    font-size: 12px;
}

.printTop div p {
    line-height: 1.25;
}

.printBox .tableName {
    font-size: 12px;
    padding: 2px 0;
    color: rgb(7, 16, 114);
    font-weight: bold;
}
.summoney {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 90%;
    margin: 10px 0 5px;
}

.summoney .sum1 span:nth-child(1) {
    color: rgb(7, 16, 114);
    font-weight: bold;
    font-size: 12px;
}

.summoney .sum1 span:nth-child(2) {
    font-size: 12px;
    color: #000;
    margin-left: 20px;
}

.insummoney {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 15% 5px 0;
    border-bottom: 1px solid #000;
}

.insummoney .sum1 span:nth-child(1) {
    color: rgb(7, 16, 114);
    font-weight: bold;
    font-size: 12px;
}

.insummoney .sum1 span:nth-child(2) {
    font-size: 12px;
    color: #000;
    margin-left: 20px;
}

.sum2 {
    border-bottom: 1px solid rgb(7, 16, 114);
    padding: 1px 0;
    display: flex;
    align-items: flex-start;
}

.sum2 p {
    color: #000;
    font-weight: normal;
    border-right: 1px solid #000;
    padding: 0 5px;
}

.sumBotn {
    display: flex;
    justify-content: space-between;
    width: 85%;
    margin: 5px 0;
}

.sumBotn p span {
    font-size: 14px;
    color: #000;
}

.sumBotn div span:first-child {
    color: rgb(7, 16, 114);
    font-weight: bold;
}

.img {
    padding-right: 5px;
}

.add_ {
    font-size: 20px;

    i {
        margin: 0 2px;
        cursor: pointer;
    }
}
//头部公共修改样式
.top_col {
    font-size: 14px;
    color: #666;
    margin: 15px 0;
    overflow: hidden;
    padding: 0 10px;
    box-sizing: border-box;
    span {
        color: #00a2ff;
    }
}
.top_cols {
    background-color: #fff;
    padding: 15px;
    padding-top: 10px;
    box-sizing: border-box;
}
.table1 {
    background-color: #fff;
    margin-top: 10px;
    padding: 10px;
    box-sizing: border-box;
    .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
}
.vxe-table--render-default .vxe-body--column:not(.col--ellipsis),
.vxe-table--render-default .vxe-footer--column:not(.col--ellipsis),
.vxe-table--render-default .vxe-header--column:not(.col--ellipsis) {
    padding: 5px 0 !important;
}
.vxe-header--column {
    font-weight: 500 !important;
}
// .el-form-item--mini.el-form-item,
// .el-form-item--small.el-form-item {
//     margin-bottom: 10px !important;
// }
// 筛选样式
.demo-drawer__content {
    overflow-y: auto;
    height: calc(100vh - 60px);
}
// 历史列表列配置样式
.filterKey_box {
    height: 100vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;

    > .box_header {
        display: flex;
        justify-content: space-between;
        padding: 16px 24px;
        font-size: 16px;
        line-height: 22px;
        border-bottom: 1px solid #e8e8e8;
        color: rgba(0, 0, 0, 0.85);

        > .icon {
            font-size: 20px;
            cursor: pointer;
        }
    }

    > .box_content {
        flex: 1;
        padding: 24px;
        display: flex;
        flex-direction: column;

        .small_box {
            display: flex;
            flex-direction: column;

            > .text {
                .big {
                    margin-right: 6px;
                    font-size: 14px;
                }

                .small {
                    font-size: 12px;
                    color: rgba(0, 0, 0, 0.45);
                }
            }

            .ul {
                margin-bottom: 15px;
                .chosen {
                    border: solid 2px #3089dc !important;
                    background-color: #3089dc !important;
                    color: #ffffff !important;
                }
                .li {
                    user-select: none;
                    position: relative;
                    box-sizing: border-box;
                    border: 1px solid #d9d9d9;
                    border-radius: 4px;
                    background-color: #fff;
                    width: 125px;
                    height: 30px;
                    float: left;
                    margin: 10px 5px 0 0;
                    color: #666;
                    font-size: 12px;
                    line-height: 30px;
                    text-align: center;
                    cursor: move;
                    list-style: none;
                    > .icon {
                        position: absolute;
                        left: 3px;
                        top: 50%;
                        transform: translateY(-50%);
                        color: #d9d9d9;
                    }

                    > .delIcon {
                        position: absolute;
                        cursor: pointer;
                        right: 3px;
                        font-size: 15px;
                        top: 50%;
                        transform: translateY(-50%);
                        color: #f4212d;
                    }

                    > .icon2 {
                        position: absolute;
                        right: 3px;
                        font-size: 15px;
                        top: 50%;
                        transform: translateY(-50%);
                        transition: 0.1s all;
                    }
                }

                .hover {
                    cursor: pointer;

                    &:hover {
                        transition: 0.1s all;
                        background-color: #c8ebfb;
                    }
                }
            }
        }

        .box_btn {
            margin-top: auto;
            text-align: right;
        }
    }
}
</style>
